/*eslint-disable*/ module.exports = {
  messages: {
    Active: 'Aktívne',
    Add: 'Pridať',
    'Add Beer Selection': 'Pridať výber pív',
    'Add Beer Servings': 'Přidat návrh servírování piva',
    'Add New dish': 'Pridať nové jedlo',
    'Add New item': 'Pridať novú položku',
    'Add Picture': 'Pridať obrázok',
    'Add QR code': 'Pridať QR kód',
    'Add Star Of The Crafters': 'Pridať Hviezdu sládkov - ČB',
    'Add Colored Star Of The Crafters': 'Pridať Hviezdu sládkov - farebná',
    'Add category or element': 'Pridať kategóriu alebo prvok',
    'Add dish': 'Pridať jedlo',
    'Add item': 'Pridat položku',
    'Add meal': 'Pridať jedlo',
    'Add new menu': 'Pridať nové menu',
    'Add other': 'Pridať ostatné',
    'Add soup': 'Pridať polievku',
    'After creating a category, you can add dishes.':
      'Po vytvorení kategórie môžete pridávať jedlá.',
    'Alcohol Content': 'Alcohol Content',
    All: 'Všetky',
    'All languages': 'Všetky jazyky',
    Allergens: 'Alergény',
    Amount: 'Množstvo',
    'Are you sure you want to delete this daily menu?':
      'Ste si istí, že chcete toto denné menu odstrániť?',
    'Are you sure you want to delete this menu?':
      'Ste si istí, že chcete toto menu odstrániť?',
    'Available only for A4 size': 'Dostupné len pre formát A4',
    'Back to Daily Menu': 'Späť',
    'Back to Food Menu': 'Späť',
    'Beer Selection': 'Výber pív',
    'Beer Type': 'Pivný štýl',
    'Beer servings': 'Kvalita piva',
    Bottom: 'Dole',
    'Brand elements': 'Brandové prvky',
    "Can't upload image": 'Obrázok nemožno nahrať',
    Cancel: 'Zrušiť',
    Categories: 'Kategórie',
    'Click to select a date': 'Vyberte dátum',
    Close: 'Zavrieť',
    Color: 'Farba',
    Continue: 'Pokračovať',
    'Copy menu': 'Kopírovať menu',
    'Country Of Origin': 'Krajina pôvodu',
    'Create Text Block': 'Vytvoriť textové pole',
    Currency: 'Mena',
    'Daily Menu': 'Denné menu',
    'Daily menu': 'Denné menu',
    Data: 'Dáta',
    'Data & Elements': 'Dáta a prvky',
    Delete: 'Vymazať',
    'Delete menu': 'Vymazať menu',
    'Delete page break': 'Odstrániť rozdeľovník stránky',
    Description: 'Popis',
    'Description (Optional)': 'Popis (Voliteľný)',
    Desserts: 'Dezerty',
    Designs: 'Návrhy',
    Displays: 'Zobrazenie',
    'Double Image Block': 'Blok dvoch obrázkov',
    Duplicate: 'Duplikovať',
    'Duplicate menu': 'Duplikovať menu',
    Edit: 'Upraviť',
    'Edit Beer Servings': 'Upraviť pivné servírovanie',
    'Edit Picture': 'Upraviť obrázok',
    'Edit QR code': 'Upraviť QR kód',
    'Edit Star Of The Crafters': 'Upravit Hviezdu sládkov - ČB',
    'Edit Colored Star Of The Crafters': 'Upravit Hviezdu sládkov - farebná',
    'Edit Text Block': 'Upraviť textové pole',
    'Edit dish': 'Upraviť jedlo',
    Elements: 'Prvky',
    Email: 'Email',
    'Error!': 'Chyba!',
    Export: 'Exportovať',
    'Export XML': 'Exportovať ako XML',
    'Export PDF': 'Exportovať ako PDF',
    'Export as JPG': 'Exportovať ako JPG',
    Fermentation: 'Druh kvasenia',
    'Fill in your contact information and we will reach back to you:':
      'Fill in your contact information and we will reach back to you:',
    'Food cards & Specials': 'Stále menu & Špeciálna ponuka',
    'Food Combinations': 'Párovanie s jedlom',
    'Food image': 'Obrázok jedla',
    'Generate QR code': 'Vytvoriť QR Kód',
    Grid: 'mriežka',
    'Hover over the tab area to see options for adding categories and elements.':
      'Pre zobrazenie možností pridania kategórií a prvkov prejdite myšou po zobrazenej oblasti.',
    'Hviezda sladkov': 'Hviezda sládkov - ČB',
    'Farebna hviezda sladkov': 'Hviezda sládkov - farebná',
    Inline: 'Medzi obsahom',
    'Jsme hrdí držitelé hvězdy sládku 2020':
      'Jsme hrdí držitelé hvězdy sládku 2020',
    Language: 'Jazyk',
    List: 'Zoznam',
    'Log in': 'Prihlásiť',
    Logo: 'Logo',
    'Logo (Not available)': 'Logo (nie je k dispozícii)',
    Logout: 'Odhlásiť',
    Meals: 'Jedlá',
    Menu: 'Menu',
    'Move Block': 'Presunúť blok',
    'Move Dish': 'Presunúť jedlo',
    'Move Dish position': 'Presunúť pozíciu jedla',
    'Move after block': 'Presunúť za blok',
    'Move after dish': 'Presunúť za jedlo',
    'Move block position': 'Presuňte polohu bloku',
    'Move to beginning': 'Presun na začiatok',
    Name: 'Názov',
    'Name of Restaurant': 'Názov reštaurácie',
    'Name of category': 'Názov kategórie',
    'category/element': 'kategoriu/prvok',
    Next: 'Ďalší',
    'No daily menus were found. Please try to change filters.':
      'Nebolo nájdené žiadne denné menu. Skúste prosím zmeniť filtre.',
    'No menus were found. Please try to change filters.':
      'Nenašli sa žiadne menu. Skúste zmeniť filtre.',
    'Ocenění za nejlepší peči o čepované pivo':
      'Ocenění za nejlepší peči o čepované pivo',
    'One column': 'Jeden stĺpec',
    'One column with image': 'Jeden stĺpec s obrázkom',
    'Order print': 'Objednať tlač',
    Other: 'Iné',
    Others: 'Ostatné',
    'Page break': 'Rozdeľovník strany',
    Phone: 'Telefónne číslo',
    Picture: 'Obrázok',
    'Please continue by logging in': 'Prihláste sa, prosím',
    Position: 'Umiestnenie',
    Preview: 'Náhľad',
    Price: 'Cena',
    'Price with soup': 'Cena s polievkou',
    'Price with meal': 'Cena s jedlom',
    'Price with soup and meal': 'Cena s polievkou a hlavným jedlom',
    Primary: 'Hlavné',
    'Secondary Primary': 'Hlavné',
    Print: 'Tlačiť',
    'QR code': 'QR kód',
    'Recommend a drink': 'Doporučiť nápoj',
    Remove: 'Odobrať',
    'Remove category': 'Odobrať kategóriu',
    'Remove dish': 'Odobrať jedlo',
    'Required field': 'Požadované pole',
    Save: 'Uložiť',
    'Select allergens': 'Vybrať alergény',
    'Serving Temperature': 'Teplota servírovania',
    'Set to active': 'Nastaviť ako aktívne',
    'Set to inactive': 'Nastaviť ako neaktívne',
    Settings: 'Nastavenia',
    Share: 'Zdieľať',
    'Share on FB': 'Zdieľať na FB',
    'Copy menu link': 'Kopírovať odkaz na menu',
    'Show Allergens': 'Zobraziť alergény',
    'Show Title Page': 'Zobraziť úvodnú stranu',
    'Show info': 'Zobraziť informácie',
    'Show name of Restaurant': 'Zobraziť názov reštaurácie',
    'Show portion size': 'Zobraziť veľkosť porcie',
    'Show text': 'Zobraziť text',
    'Show weight / bulk / pieces': 'Zobraziť gramáž/ objem/ kusy',
    Size: 'Formát',
    'Secondary Size': 'Formát',
    Soup: 'Polivka',
    'Soup can be orderer separately': 'Polievku je možné objednať zvlášť',
    'Soup priced in main dish': 'Polivka je zahrnutá v cene hlavného jedla',
    Soups: 'Polievky',
    Submit: 'Uložiť',
    Taste: 'Chuťový profil',
    Templates: 'Šablóny',
    'Text block': 'Textové pole',
    'Tips & Tricks': 'Nápoveda',
    Title: 'Názov',
    'Two columns': 'Dva stĺpce',
    'Two columns with image': 'Dva stĺpce s obrázkom',
    'Type or choose category': 'Napísať alebo vybrať kategóriu',
    'Type or choose dish': 'Napísať alebo vybrať jedlo',
    'URL address': 'URL adresa',
    Untitled: 'Bez názvu',
    'Upload image': 'Nahrať obrázok',
    'We do not offer anything for this day': 'V tento deň nevaríme',
    'We do not offer:': 'Neponúkame:',
    'Weight / bulk / pcs': 'Gramáž/ objem/ kusy',
    'Weight / bulk / pieces': 'Váha / objem / kusy',
    'You might loose some layout settings by this change. Do you wish to continue?':
      'Touto zmenou môžete prísť o niektoré nastavenia menu. Prajete si pokračovať?',
    'Známky kvalitně načepovaného piva': 'Známky kvalitně načepovaného piva',
    add: 'Pridať',
    description: 'popis',
    item: 'položka',
    language: 'jazyk',
    languange: 'jazyk',
    logo: 'logo',
    'remove page': 'odstrániť stránku',
    units: 'jednotky',
    'Secondary Menu': 'Menu',
    '{0}': [['0']],
    '{label}': [['popis']],
    'Secondary Menu': 'Menu',
    'Secondary Other': 'Ostatné',
    'Logo (Not available)': 'Logo (nie je k dispozícii)',
    "Can't upload image": 'Nemožno nahrať obrázok',
    'Description not available': 'Popis nie je k dispozícii',
    'Add Beer Selection': 'Pridať výber pív',
    'Edit Beer Selection': 'Upraviť výber piva',
    'Title is required': 'Nadpis je povinný',
    'size in cl': 'veľkosť v cl',
    'size in ml': 'veľkosť v ml',
    'Select beers': 'Vybrať pivá',
    'Mandatory field': 'Povinné pole',
    Image: 'Obrázok',
    'not available': 'nie je k dispozícií',
    'Copied successfully!': 'Úspešne skopírované!',
    'Error copied!': 'Chyba pri kopírovaní!',
    'Separate price for each item': 'Samostatná cena za každú položku',
    'Soup price is included in menu': 'Cena polievky je zahrnutá v cene menu',
    'Different price for whole menu': 'Rôzna cena za celé menu',
    'Responsibility Message': 'Správa o zodpovednosti',
    'ID:': 'ID',
    'Please complete the first 2 steps': 'Dokončite prosím prvé 2 kroky',
    'Image generation in progress. Please wait. When the download is complete, return to the list of daily menus.':
      'Generovanie obrázka prebieha. Prosím, počkajte. Po dokončení stiahnutia sa vráťte na zoznam denných menu.',
    'Are you sure you want to delete this category?':
      'Ste si istí, že chcete odstrániť túto kategóriu?',
    Yes: 'Áno',
    No: 'Nie',
    'Delete item': 'Odstrániť položku',
    'Edit element': 'Upraviť prvok',
    'Write a name': 'Napíšte názov',
    'Create category': 'Vytvoriť kategóriu',
    'Edit category': 'Upraviť kategóriu',
    'Delete category': 'Odstrániť kategóriu',
    'Choose a category': 'Vybrať kategóriu',
    Custom: 'Vlastné',
    'Add item': 'Pridať položku',
    'Add category': 'Pridať kategóriu',
    'This category already exists.': 'Táto kategória už existuje.',
    'Something went wrong, probably your file exceeds the allowed post-processing size 10Mb. Please try again with a smaller file.':
      'Niečo sa pokazilo, pravdepodobne váš súbor prekračuje povolenú veľkosť spracovania 10Mb. Skúste to znova s menším súborom.',
    'The uploaded file exceeds the maximum allowed size of 10MB. Please upload a smaller file.':
      'Nahraný súbor prekračuje maximálnu povolenú veľkosť 10MB. Nahrajte prosím menší súbor.',
    Warning: 'Varovanie',
    'You might loose some layout settings by this change. Do you wish to continue?':
      'Touto zmenou môžete prísť o niektoré nastavenia menu. Prajete si pokračovať?',
    'Bottom description': 'Popis pod menu',
    'Logo size': 'Veľkosť loga',
    Small: 'Malé',
    Medium: 'Stredné',
    Large: 'Veľké',

    Warning: 'Upozornenie',
    'Before sending the menu to the printer, please carefully check the content and graphics of the menu in the PDF preview! The printing company is not responsible for the content of the data sent in the order.':
      '„Pred odoslaním jedálneho lístka do tlačiarne si, prosím, starostlivo skontrolujte obsah a vzhľad lístka v PDF náhľade! Za vzhľad a obsah dát odoslaných do tlačiarne je vždy zodpovedný objednávateľ.“',
    'Print Parameters': 'Parametre tlače',
    Name: 'Názov',
    'Number of Menu Pages': 'Počet strán lístka',
    'Menu Format': 'Formát lístka',
    'Paper Color': 'Farba papiera',
    'Type of Binding': 'Druh väzby',
    'Paper Finish': 'Úprava povrchu',
    'Number of Copies': 'Počet kópií',
    'Price Excluding VAT:': 'Cena bez DPH:',
    'Shipping Excluding VAT:': 'Doprava bez DPH:',
    'Total Including VAT:': 'Celkom vrátane DPH:',
    'The name, number of pages, and format can only be modified in the editor menu.':
      'Názov, počet strán a formát možno upravovať len v menu editora.',
    'Menu without binding or with Twin binding are always made double-sided, Wire Stitched binding uses the entire four sides...':
      'Lístky bez väzby alebo s väzbou Twin sa vyrábajú vždy na dvojstrany, väzba Šitá drôtom používa celé štvorstrany. Ak váš lístok nemá počet strán deliteľný štyrmi, nie je možné zvoliť druh väzby Šitá drôtom. U lístka do veľkosti 4 strany tiež nie je možné voliť väzbu a lístok bude vždy vyrobený bez väzby.',
    'Billing Address': 'Fakturačná adresa',
    'First and Last Name': 'Meno a priezvisko (Názov spoločnosti)',
    'Street/No.': 'Ulica/č.p.',
    City: 'Mesto',
    'Postal Code': 'PSČ',
    Country: 'Krajina',
    'Company ID': 'IČO',
    Phone: 'Telefón',
    'E-mail': 'E-mail',
    'Different Shipping Address': 'Zásielku doručiť na inú adresu',
    'Order Summary': 'Rekapitulácia objednávky',
    'Discount Code': 'Zľavový kód',
    'Terms and Conditions': 'Obchodné podmienky',
    'The customer acknowledges that the company is not responsible for the content of data provided within the order.':
      'Zákazník berie na vedomie, že spoločnosť nenesie zodpovednosť za obsah dát poskytnutých v rámci objednávky.',
    'The customer agrees that the order will be sent on delivery.':
      'Zákazník súhlasí s tým, že objednávka bude zaslaná na dobierku.',
    'The customer confirms the order of services and agrees that their production should be started immediately.':
      'Zákazník potvrdzuje, že záväzne objednáva výrobky či služby, a súhlasí s tým, aby bola okamžite začatá ich výroba.',
    'I agree with the terms and conditions':
      'Súhlasím s obchodnými podmienkami',
    Price: 'Cena',
    'Submit Order': 'Odoslať objednávku',
    'We have received your order!': 'Prijali sme vašu objednávku!',
    'Required field': 'Toto pole je povinné',
    'We have received your order and processing it. Confirmation of your order has been sent to the email provided in the order.':
      'Vašu objednávku sme prijali na spracovanie. Potvrdenie vašej objednávky sme zaslali na e-mail uvedený v objednávke.',
    'Back to Editor': 'Späť na editor',
    'Note for the printer': 'Poznámka pre tlačiareň',
    'Without (2 pages)': 'Bez väzby (2 strany)',
    'Fold (4 pages)': 'Lom (4 strany)',
    Ring: 'Krúžková väzba',
    'Wire Stitched': 'Šitá drôtom',
    'Without Print Finish': 'Bez úpravy',
    'Matte Print Finish': 'Matná',
    'Shiny Print Finish': 'Lesklá',
    'White 250g': 'Biela',
    'Cream 250g': 'Krémová',
  },
}
